import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import DeclarationOfFaith from './components/DeclarationOfFaith';
import CampaignLanding from './components/CampaignLanding';
import ScrollToTop from './components/ScrollToTop';

const GA_MEASUREMENT_ID = 'G-T1XDD70VYB';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    const pagePath = `${location.pathname}${location.search}`;

    window.gtag('event', 'page_view', {
      send_to: GA_MEASUREMENT_ID,
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

function App() {
  return (
    <>
      <AnalyticsTracker />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/declaracion-de-fe" element={<DeclarationOfFaith />} />
        <Route path="/conocer-a-dios" element={<CampaignLanding />} />
      </Routes>
    </>
  );
}

export default App;
